"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApSlider = exports.deviceScale = void 0;
var React = require("react");
var ApSlider_styles_1 = require("./ApSlider.styles");
var ApSlider_utils_1 = require("./ApSlider.utils");
exports.deviceScale = window.devicePixelRatio;
var ApSlider = /** @class */ (function (_super) {
    __extends(ApSlider, _super);
    function ApSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isDrag: false,
            movement: 0,
            containerRef: React.createRef(),
            lineRef: React.createRef()
        };
        _this.onLineClick = function (e) {
            var _a = _this.props, disableClick = _a.disableClick, min = _a.min, onChange = _a.onChange;
            var lineRef = _this.state.lineRef;
            if (disableClick) {
                return;
            }
            var stepWidth = _this.getCurrentStepWidth();
            var lineParams = lineRef.getBoundingClientRect();
            var clickX = e.clientX - lineParams.x;
            var newValue = min + Math.round(clickX / stepWidth);
            onChange(newValue);
        };
        _this.onMouseDown = function (e) {
            var _a = _this.props, disabled = _a.disabled, onMouseDown = _a.onMouseDown, value = _a.value;
            if (!disabled) {
                e.stopPropagation();
                _this.setState({ isDrag: true });
                document.body.addEventListener('mousemove', _this.onMouseMove);
                document.body.addEventListener('mouseup', _this.onMouseUp);
                if (onMouseDown) {
                    onMouseDown(value);
                }
            }
        };
        _this.onMouseMove = function (e) {
            var _a = _this.state, containerRef = _a.containerRef, movement = _a.movement;
            var _b = _this.props, min = _b.min, max = _b.max, onChange = _b.onChange, step = _b.step, value = _b.value;
            var movementX = e.movementX, target = e.target;
            if (!containerRef.contains(target)) {
                return;
            }
            var newMovement = movement + movementX;
            var stepWidth = _this.getCurrentStepWidth() * step;
            if (Math.abs(newMovement) >= stepWidth) {
                var valueChange = value + Math.round(newMovement / stepWidth) * step;
                if (newMovement > 0) {
                    onChange(valueChange < max ? valueChange : max);
                }
                else if (newMovement < 0) {
                    onChange(valueChange > min ? valueChange : min);
                }
                _this.setState({ movement: 0 });
            }
            else {
                _this.setState({ movement: newMovement });
            }
        };
        _this.onMouseUp = function () {
            var movement = _this.state.movement;
            var _a = _this.props, max = _a.max, onChange = _a.onChange, onMouseUp = _a.onMouseUp, step = _a.step, value = _a.value;
            var stepWidth = _this.getCurrentStepWidth() * step;
            if (stepWidth <= movement * 2) {
                var valueChange = value + step;
                onChange(valueChange < max ? valueChange : max);
            }
            _this.setState({
                isDrag: false,
                movement: 0,
            });
            document.body.removeEventListener('mousemove', _this.onMouseMove);
            document.body.removeEventListener('mouseup', _this.onMouseUp);
            if (onMouseUp) {
                onMouseUp(value);
            }
        };
        _this.setContainerRef = function (ref) {
            _this.setState({
                containerRef: ref
            });
        };
        _this.setLineRef = function (ref) {
            _this.setState({
                lineRef: ref
            });
        };
        _this.getCurrentStepWidth = function () {
            var containerRef = _this.state.containerRef;
            var _a = _this.props, min = _a.min, max = _a.max;
            return ApSlider_utils_1.getStepWidth({
                ref: containerRef,
                min: min,
                max: max,
                circleWidth: ApSlider_utils_1.CIRCLE_WIDTH
            });
        };
        _this.getLeftPx = function (sliderValue) {
            var movement = _this.state.movement;
            var _a = _this.props, max = _a.max, min = _a.min;
            var stepWidth = _this.getCurrentStepWidth();
            var currentLeftPx = (sliderValue - min) * stepWidth;
            var leftPx = currentLeftPx + movement;
            if (movement > 0) {
                return leftPx / stepWidth < (max - min) ? leftPx : (max - min) * stepWidth;
            }
            else if (movement < 0) {
                return leftPx > 0 ? leftPx : 0;
            }
            return leftPx;
        };
        _this.getInitialLeftPx = function (value) {
            var min = _this.props.min;
            var stepWidth = _this.getCurrentStepWidth();
            return (value - min) * stepWidth + ApSlider_utils_1.CIRCLE_WIDTH / 2;
        };
        return _this;
    }
    ApSlider.prototype.render = function () {
        var isDrag = this.state.isDrag;
        var _a = this.props, disabled = _a.disabled, label = _a.label, initialValue = _a.initialValue, value = _a.value, min = _a.min, max = _a.max;
        var valueLeftPx = this.getLeftPx(value);
        var labelAlign = 'center';
        var stepWidth = this.getCurrentStepWidth();
        if (label.length > 3) {
            if ((max - value) * stepWidth < 36) {
                labelAlign = 'right';
            }
            else if ((value - min) * stepWidth < 36) {
                labelAlign = 'left';
            }
        }
        return (React.createElement(ApSlider_styles_1.Container, { ref: this.setContainerRef },
            React.createElement(ApSlider_styles_1.Line, { ref: this.setLineRef, disabled: disabled, onClick: this.onLineClick }),
            initialValue !== undefined ? (React.createElement(ApSlider_styles_1.InitialValue, { left: this.getInitialLeftPx(initialValue) })) : null,
            React.createElement(ApSlider_styles_1.Value, { isDrag: isDrag, left: valueLeftPx },
                React.createElement(ApSlider_styles_1.ValueText, { align: labelAlign }, label),
                React.createElement(ApSlider_styles_1.ValueCircle, { disabled: disabled, onMouseDown: this.onMouseDown }))));
    };
    return ApSlider;
}(React.Component));
exports.ApSlider = ApSlider;
;
ApSlider.defaultProps = {
    step: 1,
    min: 0,
    max: 100,
};
//# sourceMappingURL=ApSlider.js.map